import { render, staticRenderFns } from "./DepositNewSummaryNV.vue?vue&type=template&id=7036142a"
import script from "./DepositNewSummaryNV.vue?vue&type=script&lang=js"
export * from "./DepositNewSummaryNV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7036142a')) {
      api.createRecord('7036142a', component.options)
    } else {
      api.reload('7036142a', component.options)
    }
    module.hot.accept("./DepositNewSummaryNV.vue?vue&type=template&id=7036142a", function () {
      api.rerender('7036142a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/DepositNewSummaryNV.vue"
export default component.exports